import SchoolOptionsAdapter from './base';

export default class Heading extends SchoolOptionsAdapter {
  modelNamePlural = 'optionHeadings';

  pathForType(type) {
    type = type.replace(/^school-options\/headings?/, `schema/optionheadings`);
    return type;
  }
}
